import { useBacklogSelector } from '../../../state/index.tsx';
import { getRapidViewId } from '../../../state/selectors/app/index.tsx';

export const useBoardId = () => Number(useBacklogSelector(getRapidViewId));
